import { useRequest } from "@prismicio/editor-support/Suspense"
import type { FilterOption } from "@prismicio/editor-ui"

import {
  getRepository,
  getRepositoryTags,
  useCustomTypes,
} from "../../../core/service"
import { throwConfigError, useEditorConfig } from "../../../EditorConfig"

export function useRepositoryLocales(): Set<FilterOption> {
  const config = useEditorConfig()
  if (!config.searchDocuments) throwConfigError("searchDocuments")

  const { coreApiBaseUrl, authStrategy } = config

  const repositoryLocales = useRequest(getRepository, [
    coreApiBaseUrl,
    authStrategy,
  ])

  return new Set(
    repositoryLocales.languages.map((lang) => ({
      id: lang.id,
      label: lang.label,
    })),
  )
}

export function useRepositoryTags(): Set<FilterOption> {
  const config = useEditorConfig()
  if (!config.searchDocuments) throwConfigError("searchDocuments")

  const { coreApiBaseUrl, authStrategy } = config

  const repositoryTags = useRequest(getRepositoryTags, [
    coreApiBaseUrl,
    authStrategy,
  ])

  return new Set(repositoryTags.results.map((tag) => ({ id: tag, label: tag })))
}

export function useRepositoryTypes(): Set<FilterOption> {
  const config = useEditorConfig()
  if (!config.searchDocuments) throwConfigError("searchDocuments")

  const { customTypesApiBaseUrl, repository, authStrategy } = config

  const repositoryTypes = useCustomTypes({
    baseUrl: customTypesApiBaseUrl,
    repository,
    authStrategy,
  })

  return new Set(repositoryTypes.data)
}
